import React from 'react'
import { GridCell, GridFilterCell } from '@progress/kendo-react-grid'
import { DropDownList } from '@/components/dropDownList'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import { isDefinedAndNotEmpty } from '@/utils/isDefined'
import { Column } from '@/components/BsrsGrid/index'

class BooleanCell extends GridCell {
  render () {
    const value = this.props.dataItem[this.props.field]
    return <td>{value === true ? <Resx name='Common.Yes' /> : <Resx name='Common.No' />}</td>
  }
}

const dropDownItems = [{ value: 1, text: 'Common.Yes' }, { value: 0, text: 'Common.No' }]

function transform (transformation) {
  return function (item) {
    item = { ...item }
    transformation(item)
    return item
  }
}

class BooleanCellStatus extends GridCell {
  render () {
    const value = this.props.dataItem[this.props.field]
    if (typeof value !== 'boolean') {
      return (<td>-</td>)
    }
    return (<td className='td-status'>
      {value ? <span className='status status--accepted'><Resx name='Common.Yes' /></span> : <span className='status status--rejected'><Resx name='Common.No' /></span>}
    </td>)
  }
}

@localized()
class BooleanFilterCell extends GridFilterCell {
  onValueChange = ({ value }) => {
    this.props.onChange({
      value: value === null || value === undefined ? '' : value,
      operator: value === null || value === undefined ? '' : 'eq'
    })
  }

  render () {
    const { value, localize } = this.props
    const data = dropDownItems.map(transform(x => {
      x.text = localize(x.text)
    }))
    return (
      <div>
        <div className={'k-filtercell' + (isDefinedAndNotEmpty(this.props.value) ? ' k-filtercell-filtered' : '')}>
          <DropDownList
            data={data}
            valueField='value'
            textField='text'
            onChange={this.onValueChange}
            value={value}
            allowClear={isDefinedAndNotEmpty(value)}
          />
        </div>
      </div>
    )
  }
}

const BooleanColumn = ({ localize, ...props }) => {
  const exportCell = ({ dataItem, field, type, localize }) => {
    return dataItem[field] === true ? localize('Common.Yes') : localize('Common.No')
  }

  return <Column cell={BooleanCell} filterCell={BooleanFilterCell} cellExport={exportCell} {...props} />
}

export {
  BooleanCell,
  BooleanCellStatus,
  BooleanFilterCell,
  BooleanColumn
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/booleanCell.js